import classNames from 'classnames';
import React from 'react';
import { Loader } from '../../../components/Loader';
import { TColor, TSize, TVariant } from '../model/types/types';
import './MButton.scss';

type Props = {
  color?: TColor;
  variant?: TVariant;
  size?: TSize;
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  id?: string;
  loading?: boolean;
};

export const MButton: React.FC<Props> = ({
  color = 'primary',
  variant = 'default',
  size = 'sm',
  className = '',
  children,
  disabled,
  onClick = () => {},
  id,
  loading,
}) => {
  return (
    <button
      id={id}
      onClick={onClick}
      disabled={disabled}
      className={classNames(`MButton`, className, variant, color, size, {
        disabled,
      })}
    >
      {children}
      {loading && <Loader className="-mr-4 max-h-6 max-w-6" />}
    </button>
  );
};
